import * as React from 'react'
import { FC, useMemo, useCallback } from 'react'
import { useField, useFormikContext } from 'formik'
import CollapsibleFilter from './atoms/CollapsibleFilter'
import { ValueRange, IFilterProps } from '../typings'
import { currencyString } from '@sales-center/common'

import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

export const ValueRangeFilter: FC<IFilterProps> = ({ name, label, reset }) => {
  const path = `filters.${name}.value`
  const minPath = `${path}.min`
  const maxPath = `${path}.max`

  const { setFieldValue } = useFormikContext()

  const [
    {
      value: { min, max },
    },
  ] = useField<ValueRange>(path)

  const onChangeMin = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = event
      setFieldValue(minPath, value)
    },
    [minPath, setFieldValue],
  )

  const onBlurMin = useCallback(() => {
    if (min !== '') {
      const value = currencyString(min)
      setFieldValue(minPath, value)
    }
  }, [min, minPath, setFieldValue])

  const onChangeMax = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const {
        currentTarget: { value },
      } = event
      setFieldValue(maxPath, value)
    },
    [maxPath, setFieldValue],
  )

  const onBlurMax = useCallback(() => {
    if (max !== '') {
      const value = currencyString(max)
      setFieldValue(maxPath, value)
    }
  }, [max, maxPath, setFieldValue])

  const subLabel = useMemo(() => {
    let label = ''

    if (min !== '') label = `Min $${min}`
    if (max !== '') {
      if (label === '') label = `Max $${max}`
      else label += ` - Max $${max}`
    }

    return label
  }, [max, min])

  return (
    <CollapsibleFilter
      label={label}
      subLabel={(expanded) => !expanded && subLabel}
      reset={reset}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs>
          <TextField
            value={min}
            onChange={onChangeMin}
            onBlur={onBlurMin}
            label="Min"
            size="small"
            fullWidth
          />
        </Grid>
        <Grid item xs={1}>
          <Typography>To</Typography>
        </Grid>
        <Grid item xs>
          <TextField
            value={max}
            onChange={onChangeMax}
            onBlur={onBlurMax}
            label="Max"
            size="small"
            fullWidth
          />
        </Grid>
      </Grid>
    </CollapsibleFilter>
  )
}
ValueRangeFilter.displayName = 'ValueRangeFilter'
